// extracted by mini-css-extract-plugin
export default {"cantRateCheckbox":"cantRateCheckbox___f61fb3d98e990d3d","container":"container___f730daf6e43f47f1"};